import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect } from 'react';
import axios from 'axios';

const Popup2 = (props) => {
  const [managerComment, setManagerComment] = React.useState('');
  const updateStatus = () => {
    axios
      .put(`${process.env.REACT_APP_API_URL}/task/manager-comment`, {
        id: props.item._id,
        managerComment,
      })
      .then((res) => {
        props.handleClose(true, res.data.message);
      })
      .catch((err) => {
        props.handleClose(false, err.response.data.message);
      });
  };

  const open = true;
  useEffect(() => {
    setManagerComment(props.item.managerComment);
  }, [props.item]);

  return (
    <>
      <Dialog onClose={props.handleClose} open={open}>
        <DialogTitle>Update Manager Comment</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Stack
              mt={2}
              spacing={2}
              sx={{
                minWidth: {
                  xs: '100%',
                  sm: '500px',
                },
              }}
            >
              <TextField
                autoFocus
                margin="dense"
                id="managerComment"
                label="Manager Comment"
                value={managerComment}
                type="text"
                fullWidth
                onChange={(e) => setManagerComment(e.target.value)}
              />
            </Stack>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose}>Cancel</Button>
          <Button onClick={updateStatus} variant="contained">
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Popup2;
